/*
 * Copyright 2026 OpenTrace Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Suspense, type HTMLAttributes } from 'react';
import type { Components } from 'react-markdown';

const MermaidDiagram = React.lazy(() => import('./MermaidDiagram'));

// eslint-disable-next-line react-refresh/only-export-components
function CodeBlock({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLElement>) {
  const isMermaid = className === 'language-mermaid';

  if (isMermaid && typeof children === 'string') {
    return (
      <Suspense>
        <MermaidDiagram code={children.trimEnd()} />
      </Suspense>
    );
  }

  return (
    <code className={className} {...rest}>
      {children}
    </code>
  );
}

export const markdownComponents: Components = {
  code: CodeBlock,
};
